export default __webpack_public_path__ + "static/media/Xero_software_logo.b0d4232d.svg";